import { schedulerTypes } from '@/utils/hooks/context/toast/types';

export const NOTIFICATION_CONFIGS = {
    [schedulerTypes.POST_UPDATED]: {
        icon: 'edit',
        bgColor: 'bg-icoBlue',
        title: 'commons:notifications.scheduler_post_updated.title',
        description: 'commons:notifications.scheduler_post_updated.description'
    },
    [schedulerTypes.POST_PUBLISHED_FAILED]: {
        icon: 'exclamation-point',
        bgColor: 'bg-icoRed',
        title: 'commons:notifications.scheduler_post_publish_failed.title',
        description: 'commons:notifications.scheduler_post_publish_failed.description'
    },
    [schedulerTypes.POST_APPROVED_INFO]: {
        icon: 'check',
        bgColor: 'bg-icoBlue',
        title: 'commons:notifications.scheduler_post_approved_info.title',
        description: 'commons:notifications.scheduler_post_approved_info.description'
    },
    [schedulerTypes.POST_APPROVED_ACTION_REQUIRED]: {
        icon: 'alert',
        bgColor: 'bg-icoBlue',
        title: 'commons:notifications.scheduler_post_approved_action_required.title',
        description: 'commons:notifications.scheduler_post_approved_action_required.description'
    },
    [schedulerTypes.POST_REJECTED_INFO]: {
        icon: 'rejected',
        bgColor: 'bg-icoRed',
        title: 'commons:notifications.scheduler_post_rejected_info.title',
        description: 'commons:notifications.scheduler_post_rejected_info.description'
    },
    [schedulerTypes.POST_REJECTED_ACTION_REQUIRED]: {
        icon: 'alert',
        bgColor: 'bg-icoRed',
        title: 'commons:notifications.scheduler_post_rejected_action_required.title',
        description: 'commons:notifications.scheduler_post_rejected_action_required.description'
    },
    [schedulerTypes.MULTIPOST_APPROVED_INFO]: {
        icon: 'check',
        bgColor: 'bg-icoGreen',
        title: 'commons:notifications.scheduler_multipost_approved_info.title',
        description: 'commons:notifications.scheduler_multipost_approved_info.description'
    },
    [schedulerTypes.MULTIPOST_APPROVED_ACTION_REQUIRED]: {
        icon: 'alert',
        bgColor: 'bg-icoBlue',
        title: 'commons:notifications.scheduler_multipost_approved_action_required.title',
        description:
            'commons:notifications.scheduler_multipost_approved_action_required.description'
    }
} as const;

export const TIME_FORMAT_DEFAULT = '24' as const;
export const TIMEZONE_DEFAULT = 'Europe/Paris' as const;
